/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DiscountTypeEnum = {
    Percent: 'percent',
    Amount: 'amount'
} as const;
export type DiscountTypeEnum = typeof DiscountTypeEnum[keyof typeof DiscountTypeEnum];


export function instanceOfDiscountTypeEnum(value: any): boolean {
    for (const key in DiscountTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(DiscountTypeEnum, key)) {
            if (DiscountTypeEnum[key as keyof typeof DiscountTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DiscountTypeEnumFromJSON(json: any): DiscountTypeEnum {
    return DiscountTypeEnumFromJSONTyped(json, false);
}

export function DiscountTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountTypeEnum {
    return json as DiscountTypeEnum;
}

export function DiscountTypeEnumToJSON(value?: DiscountTypeEnum | null): any {
    return value as any;
}

export function DiscountTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DiscountTypeEnum {
    return value as DiscountTypeEnum;
}

